import service from '../service.js'

export default{

    listJobDescription(search)
    {
        return service.get('job-description',
        {
            search : search
        })
    },

    uploadJobDescription(position_key, remarks, source)
    {
        return service.post('job-description',
        {
            position_key : position_key,
            remarks      : remarks,
            source       : source,
        })
    },

    getFileDescription(key)
    {
        return service.get('job-description/' + key)
    },
}